import React from "react";

import Grid from "../../components/Grid/Grid";
import * as classes from "./Game.module.css";

export default function Game() {
  return (
    <div className={classes.Game}>
      <div className={classes.Info}>
        <p>
          Here you can enjoy a relaxing game of sudoku at varying difficulties,
          or you can simply watch the recursive backtracking algorithm solve the
          puzzle.
        </p>
      </div>
      <Grid />
      <div className={classes.Directions}>
        <h2>How to Play Sudoku</h2>
        <ul>
          <li>
            There are 9 grids (with 9 cells each), totaling up to 81 cells
            total.
          </li>
          <li>Each cell can have a value of from 1 - 9.</li>
          <li>
            <b>
              To solve the puzzle, each cell must be filled with a value. Each
              row, column, and grid must be filled with a number 1 - 9 once.
            </b>
          </li>
        </ul>
      </div>
    </div>
  );
}
